// extracted by mini-css-extract-plugin
export default {"batteryContainer":"style_batteryContainer__LOHv6"};